import { useEffect, useState } from 'react';

import { MATRIX_BLUE, MATRIX_RED } from '../constants';

export function GlitchText({ text, className = '', style = {} }: { text: string; className?: string; style?: React.CSSProperties }) {
  const [displayText, setDisplayText] = useState(text);
  const glitchChars = 'アイウエオカキクケコ0123456789!@#$%^&*';

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    let interval: NodeJS.Timeout;

    function runGlitch() {
      let iterations = 0;
      const maxIterations = 8;
      interval = setInterval(() => {
        iterations += 1;
        setDisplayText(
          text
            .split('')
            .map((char) => {
              if (char === ' ' || char === '.') return char;
              if (Math.random() > 0.3) return char;
              return glitchChars[Math.floor(Math.random() * glitchChars.length)];
            })
            .join('')
        );
        if (iterations >= maxIterations) {
          clearInterval(interval);
          setDisplayText(text);
          timeout = setTimeout(runGlitch, 3000 + Math.random() * 3000);
        }
      }, 60);
    }

    timeout = setTimeout(runGlitch, 2000);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [text]);

  return (
    <span className={className} style={{ ...style, display: 'inline-block', position: 'relative' }}>
      <span style={{ position: 'relative', zIndex: 1 }}>{displayText}</span>
      <span aria-hidden='true' style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, color: MATRIX_RED, opacity: 0, clipPath: 'inset(10% 0 60% 0)', transform: 'translate(-2px, 0)', animation: 'glitch-clip-red 4s infinite', zIndex: 0, pointerEvents: 'none' }}>
        {displayText}
      </span>
      <span aria-hidden='true' style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, color: MATRIX_BLUE, opacity: 0, clipPath: 'inset(50% 0 20% 0)', transform: 'translate(2px, 0)', animation: 'glitch-clip-blue 4s infinite 0.1s', zIndex: 0, pointerEvents: 'none' }}>
        {displayText}
      </span>
    </span>
  );
}
